import posthog, { type PostHog } from 'posthog-js';

import { HAS_POSTHOG_CONFIG } from './posthog';

// Returns the PostHog client when PostHog is configured, otherwise undefined.
// Use it with optional chaining so the call does nothing when PostHog is off:
//   getPostHog()?.capture('booking_created', { ... })
export function getPostHog(): PostHog | undefined {
  if (typeof window === 'undefined') return undefined;

  if (!HAS_POSTHOG_CONFIG) return undefined;

  return posthog;
}
